import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NewPortalVersionWarningComponent } from '../components/new-portal-version-warning/new-portal-version-warning.component';

@Injectable({
  providedIn: 'root',
})
export class SnackMessageService {
  private snackBar = inject(MatSnackBar);

  private newVersionAvailable = false;

  public openNewPortalVersionWarning() {
    const snackBarPersistantRef = this.snackBar.openFromComponent(NewPortalVersionWarningComponent, {
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
      panelClass: 'persistant-snackbar',
      duration: undefined,
    });
    this.newVersionAvailable = true;

    return snackBarPersistantRef;
  }
}
